import FloatLabelCard from '@/components/float-label-card';
import InputControl from '@/components/form/input-control';
import { getErrorText } from '@/components/form/input-control/helpers';
import Icon from '@/components/icon';
import Text from '@/components/text';
import Tooltip from '@/components/tooltip';
import useFeature from '@/hooks/use-feature.hook';
import { FormHandle } from '@/hooks/use-form-handle.hook';
import { TelemetryModel } from '@/lib/models/telemetry/telemetry.model';
import { Box, Divider, FormHelperText, Stack } from '@mui/material';
import { FC } from 'react';
import { createUseStyles } from 'react-jss';

interface Props {
  formHandle: FormHandle<TelemetryModel>;
}

const useStyles = createUseStyles({
  telemetryTypes: {
    '& .MuiFormControl-root': {
      margin: 0,
    },
  },
});

const TelemetryTypes: FC<Props> = ({ formHandle }) => {
  const styles = useStyles();
  const { canConfigureConversationExport } = useFeature();

  const { values, setFieldValue } = formHandle;

  const {
    errors: { telemetryTypes: errorText },
  } = formHandle;
  const hasError = !!errorText;

  const handleChangeUserEvents = (checked: boolean) => {
    if (!checked) {
      setFieldValue('telemetryTypes.userEvents.includeConversationData', false);
    }
  };

  const userEventsEnabled = values.telemetryTypes.userEvents.enabled;

  return (
    <>
      <FloatLabelCard label="Telemetry Source Activation" className={styles.telemetryTypes}>
        <Stack mt={1} gap={1}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
            <Box flexGrow={1}>
              <Text size="small">User Events</Text>
            </Box>
            <InputControl
              name="telemetryTypes.userEvents.enabled"
              label=""
              type="switch"
              size="small"
              formHandle={formHandle}
              inline
              fullWidth={false}
              onChange={handleChangeUserEvents}
            />
          </Stack>

          <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
            <Stack direction="row" flexGrow={1}>
              <Icon
                name="sub-arrow-right"
                size="small"
                color={userEventsEnabled ? 'black' : 'grey'}
              />
              <Text size="small" color={userEventsEnabled ? 'black' : 'grey'}>
                Conversation Data
              </Text>
            </Stack>
            <Tooltip
              title="You must be an organization owner to enable/disable conversation data delivery"
              disabled={canConfigureConversationExport}
            >
              <InputControl
                name="telemetryTypes.userEvents.includeConversationData"
                label=""
                type="switch"
                size="small"
                formHandle={formHandle}
                inline
                fullWidth={false}
                disabled={!userEventsEnabled || !canConfigureConversationExport}
              />
            </Tooltip>
          </Stack>
          <Divider />

          <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
            <Box flexGrow={1}>
              <Text size="small">Audit Events</Text>
            </Box>
            <InputControl
              name="telemetryTypes.auditEvents.enabled"
              label=""
              type="switch"
              size="small"
              formHandle={formHandle}
              inline
              fullWidth={false}
            />
          </Stack>
        </Stack>
      </FloatLabelCard>
      {hasError && (
        <Box mt={0.5}>
          <FormHelperText error>{getErrorText(errorText)}</FormHelperText>
        </Box>
      )}
    </>
  );
};

export default TelemetryTypes;
